import { Form, Row, Col } from 'react-bootstrap';
import { CreditCard, Key, Save, Activity, RefreshCw, Settings } from 'lucide-react';
import SubscriptionInfoCard from '../../molecules/SubscriptionInfoCard/view';
import ButtonBasic from '../../atoms/buttonBasic/view';
import PlanDisplay from '../../molecules/PlanDisplay/view';
import { SubscriptionPaymentMethod, SubscriptionStatus } from '../../../domain/suscriptions/model';
import './style.css';

const SubscriptionSettingsForm = ({
    userName,
    subscription,
    selectedPaymentMethod,
    onPaymentMethodChange,
    selectedStatus,
    onStatusChange,
    newPlemsiToken,
    onPlemsiTokenChange,
    tokenError,
    onSavePlemsiToken,
    isChangingPlan,
    onToggleChangingPlan,
    onSetPlan,
    onInitializeConfig
}) => {
    return (
        <div className="subscription-settings-container">
            <header className="settings-header">
                <p>Gestiona tu plan y facturación para <strong>{userName}</strong></p>
            </header>

            {!isChangingPlan ? (
                <>
                    <SubscriptionInfoCard subscription={subscription} />

                    <div className="settings-actions-bar">
                        <button className="text-action-btn" onClick={onToggleChangingPlan}>
                            <RefreshCw size={14} /> Cambiar Plan
                        </button>
                        <button className="text-action-btn config-init" onClick={onInitializeConfig} style={{ color: '#6366f1' }}>
                            <Settings size={14} /> Inicializar Configuración
                        </button>
                    </div>

                    <Row>
                        <Col md={6}>
                            <section className="settings-section">
                                <Form.Label className="section-label">Método de Pago</Form.Label>
                                <div className="custom-select-wrapper">
                                    <div className="input-icon-prefix">
                                        <CreditCard size={18} />
                                    </div>
                                    <Form.Select
                                        value={selectedPaymentMethod}
                                        onChange={onPaymentMethodChange}
                                        className="custom-select-input"
                                    >
                                        <option value={SubscriptionPaymentMethod.CREDIT_CARD}>💳 Tarjeta de Crédito</option>
                                        <option value={SubscriptionPaymentMethod.CASH}>💵 Efectivo / Otros</option>
                                    </Form.Select>
                                </div>
                            </section>
                        </Col>
                        <Col md={6}>
                            <section className="settings-section">
                                <Form.Label className="section-label">Estado</Form.Label>
                                <div className="custom-select-wrapper">
                                    <div className="input-icon-prefix">
                                        <Activity size={18} />
                                    </div>
                                    <Form.Select
                                        value={selectedStatus}
                                        onChange={onStatusChange}
                                        className="custom-select-input"
                                    >
                                        <option value={SubscriptionStatus.ACTIVE}>🟢 Activa</option>
                                        <option value={SubscriptionStatus.TRIAL}>🛡️ Prueba (Trial)</option>
                                        <option value={SubscriptionStatus.PENDING}>🟠 Pendiente</option>
                                        <option value={SubscriptionStatus.CANCELLED}>🔴 Cancelada</option>
                                        <option value={SubscriptionStatus.EXPIRED}>💀 Expirada</option>
                                    </Form.Select>
                                </div>
                            </section>
                        </Col>
                    </Row>

                    <section className="settings-section">
                        <Form.Label className="section-label">Plemsi Token</Form.Label>
                        <Row className="align-items-start">
                            <Col>
                                <div className="custom-input-wrapper">
                                    <div className="input-icon-prefix">
                                        <Key size={18} />
                                    </div>
                                    <Form.Control
                                        type="text"
                                        value={newPlemsiToken}
                                        onChange={(e) => onPlemsiTokenChange(e.target.value)}
                                        isInvalid={!!tokenError}
                                        className="custom-text-input"
                                        placeholder="Ingresar Token"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {tokenError}
                                    </Form.Control.Feedback>
                                </div>
                            </Col>
                            <Col xs="auto">
                                <ButtonBasic
                                    id="save-token"
                                    title="Guardar"
                                    onClick={onSavePlemsiToken}
                                    className="save-token-btn"
                                    showLoading={true}
                                />
                            </Col>
                        </Row>
                    </section>
                </>
            ) : (
                <div className="change-plan-container">
                    <div className="change-plan-header">
                        <h3>Seleccionar Nuevo Plan</h3>
                        <button className="text-action-btn cancel" onClick={onToggleChangingPlan}>
                            Volver
                        </button>
                    </div>
                    <PlanDisplay SetSelectedPlan={onSetPlan} />
                </div>
            )}
        </div>
    );
};

export default SubscriptionSettingsForm;
